const url = document.location.toString();
const hash = url.split('#')[1];

if (url.match('#')) {
  $(`.nav-tabs a[href="#${hash}"]`).tab('show');
}

$('.nav-tabs a').on('click', (e) => {
  window.location.hash = e.target.hash;
});
